export default __webpack_public_path__ + "static/media/abi.fcd17e50.png";